import initCCPInvisible from '@/ccp/initCCP-invisible';
import { useAppDispatch, useAppSelector } from '@/redux/hooks/useAppSelector';
import { connectAgentActions } from '@/redux/slices';
import { Modal } from 'antd';
import { useEffect } from 'react';
import AwsConnectModal from './AwsConnectModal';

const AwsCCP: React.FC = () => {
  const isCcpInitialed = useAppSelector((state) => state.connect.initialed);
  const connectModalOpen = useAppSelector((state) => state.connect.modalOpen);
  const dispatch = useAppDispatch();
  const onConnectModalClose = () => {
    dispatch(connectAgentActions.setConnectModalOpen(false));
  };
  useEffect(() => {
    if (connectModalOpen && !isCcpInitialed) {
      initCCPInvisible();
    }
  }, [connectModalOpen]);
  return (
    <>
      <Modal open={connectModalOpen} onCancel={onConnectModalClose} footer={false} title="Calling Contact" destroyOnClose={true} forceRender>
        <AwsConnectModal connectModalOpen={connectModalOpen} />
      </Modal>
    </>
  );
};

export default AwsCCP;
